export class TaxRateMasterRequest {
  webApiName: string;
  webApiVersion: number;
  requestId: string;
  requestInfo: TaxRateMasterRequestInfo;
}

export class TaxRateMasterRequestInfo {
  taxRateMasterId: number;
  organisationId: number;
  taxCode: string;
  taxRate: number;
  taxAccountingCode: string;
  effectiveFrom: string;
  isActive: boolean;
  futureRateOf: number;
  isFutureRate: boolean;
  sortOrderDesc: boolean;
  sortColumn: string;
  createdBy: number;
  createdOn: number;
  updatedBy: number;
  updatedOn: number;
}
